import { create } from 'zustand';
import type { CatalogField, CatalogOption, CatalogResponse, FilterCategory } from '../types/analytics.types';

/**
 * The field catalog the backend can actually query, loaded once per org from
 * GET /analytics/catalog. The Query Builder, the confirmation view and the
 * output selector all read from here, so the portal never offers a filter the
 * engine cannot run.
 */
interface CatalogState {
  loaded: boolean;
  categories: Array<{ key: FilterCategory; label: string }>;
  fields: CatalogField[];
  groupBy: CatalogOption[];
  trendMetrics: CatalogOption[];
  setCatalog: (catalog: CatalogResponse) => void;
}

export const useCatalogStore = create<CatalogState>()((set) => ({
  loaded: false,
  categories: [],
  fields: [],
  groupBy: [],
  trendMetrics: [],
  setCatalog: (catalog) =>
    set({
      loaded: true,
      categories: catalog.categories,
      fields: catalog.fields,
      groupBy: catalog.groupBy,
      trendMetrics: catalog.trendMetrics,
    }),
}));
